import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const AnotherIssue: FC<ISvgProps> = ({ primaryColor = '#191919' }) => {
	return (
		<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M34.3334 52.2083L28.2667 44.625H17.0001C16.4254 44.625 15.8743 44.3967 15.468 43.9904C15.0617 43.5841 14.8334 43.033 14.8334 42.4583V18.8482C14.8334 18.2735 15.0617 17.7224 15.468 17.3161C15.8743 16.9098 16.4254 16.6815 17.0001 16.6815H51.6668C52.2414 16.6815 52.7925 16.9098 53.1988 17.3161C53.6051 17.7224 53.8334 18.2735 53.8334 18.8482V42.4583C53.8334 43.033 53.6051 43.5841 53.1988 43.9904C52.7925 44.3967 52.2414 44.625 51.6668 44.625H40.4001L34.3334 52.2083ZM38.3179 42.4583H51.6668V18.8482H17.0001V42.4583H30.3489L34.3334 48.6631L38.3179 42.4583ZM8.33341 7.79166H45.1668V9.95833H8.33341V35.9583H6.16675V9.95833C6.16675 9.3837 6.39502 8.83259 6.80135 8.42627C7.20768 8.01994 7.75878 7.79166 8.33341 7.79166Z"
				fill="#5977EB"
			/>
		</svg>
	);
};
